export const BASE_URL = "https://backend.dovehousecapital.com/public/api/";
